var _a;
import { __decorate, __metadata } from "tslib";
import { MergeApi } from '../descriptors/merge-api.descriptor';
import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
export class CommentsAPI {
    static getCommentsApi(params) {
        const { folder_id, data_ids = [], comment_limit = -1, data_type = 'PATENT', need_comment_structure = true, sort = 'ASC', visible_scope = 'ALL', } = params;
        return psHttp({
            url: `${workspaceApiUrlPrefix}/comment/folder/${folder_id}/comment-list`,
            method: 'POST',
            data: {
                data_ids,
                comment_limit,
                data_type,
                need_comment_structure,
                sort,
                visible_scope,
            },
            transformCode: true,
        }).then(({ data }) => {
            return data.data || {};
        });
    }
    static getCommentsWithMergeApi(params) {
        return this.getCommentsApi(params).then(res => {
            return res;
        });
    }
    static getCommentApi(params) {
        return psHttp({
            url: `${workspaceApiUrlPrefix}/comment/folder/${params.folder_id}/data/${params.data_id}`,
            method: 'GET',
            params,
            transformCode: true,
        }).then(({ data }) => {
            return data.data || {};
        });
    }
    static addCommentApi(params) {
        return psHttp({
            url: `${workspaceApiUrlPrefix}/comment/folder/${params.folder_id}/data/${params.data_id}`,
            method: 'POST',
            data: params,
            transformCode: true,
        }).then(({ data }) => {
            return data.data || {};
        });
    }
    static updateCommentApi(params) {
        return psHttp({
            url: `${workspaceApiUrlPrefix}/comment/folder/${params.folder_id}/data/${params.data_id}/comment/${params.comment_id}`,
            method: 'PUT',
            data: params,
            transformCode: true,
        }).then(({ data }) => {
            return data.data || {};
        });
    }
    static deleteCommentApi(params) {
        return psHttp({
            url: `${workspaceApiUrlPrefix}/comment/folder/${params.folder_id}/comment/${params.comment_id}`,
            method: 'DELETE',
            transformCode: true,
        }).then(({ data }) => {
            return data.data || {};
        });
    }
}
__decorate([
    MergeApi({ delay: 800 }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], CommentsAPI, "getCommentsWithMergeApi", null);
